export const DATA_KEY_IS_LOCKED = "mpse__locking__model__is_locked";
